import React from 'react'
import {Carousel} from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import img1 from "../assets/Untitled1.png"
import img2 from "../assets/Untitled3.png"

export default function Services() {
  return (
    <div className='services'>
     <Carousel infiniteLoop autoPlay showStatus={false} showArrows={false} showThumbs={false} interval={1000}>
         <div>
            <img height={"700px"} width={"300px"} src={img1} alt="Item1" />
            <p className='legend'>Full Stack</p>
         </div>
         <div>
            <img height={"700px"} width={"300px"} src={img2} alt="Item1" />
            <p className='legend'>Mobile Development</p>
         </div>
     </Carousel>
    </div>
  )
}

